<template>
  <div class="app-main-content">
    <div class="grid-view">
      <div v-show="view==='list'" class="main-content">
        <search-item
          ref="searchItem"
          config-module="119214"
          :expand-adv="true"
          :show-simple="false"
          :custom-search-items="customSearchItems"
          @advSearchItemCallBack="queryHandler"
        >
          <div slot="operations">
            <el-button type="success" :disabled="!selectedRow" no="view" @click="detail">{{ $t('CargoMsg.Cargo_View') }}</el-button>
            <el-button type="primary" :disabled="(!selectedRow || selectedRow.status === 2)" no="edit" @click="edit">{{ $t('CargoMsg.Cargo_Edit') }}</el-button>
            <el-button type="primary" no="add" @click="add">{{ $t('CargoMsg.Cargo_Add') }}</el-button>
            <el-button type="primary" no="revoke" @click="revoke">{{ $t('CargoMsg.Cargo_Revoke') }}</el-button>
            <el-button type="primary" no="Clone" @click="copy()">{{ $t('SeaExport.Clone') }}</el-button>
            <el-button type="primary" no="print" @click="toPrint">{{ $t('CargoMsg.Cargo_Print') }}</el-button>
          </div>
        </search-item>
        <div style="flex-grow: 1;min-height: 350px;">
          <cargo-ag-grid-wrapper
            config-module="2025050261"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
            :show-selected-color="false"
            :check-sub-record="false"
            style="height: 100%;"
            @gridReady="params=>{gridApi=params.api}"
          />
        </div>
        <div class="pagination-wrapper">
          <cargo-pagination
            config-module="2025050261"
            :total="filter.total"
            :page.sync="filter.pageNum"
            :limit.sync="filter.pageSize"
            @pagination="fetchDataByPage"
          />
        </div>
      </div>
      <!--询价详情-->
      <inquiry-sea-fcl-detail
        v-if="view==='detail'"
        ref="inquiryDetail"
        source="CarFormTab"
        @loadSalesPrivateCustomer="loadSalesPrivateCustomer"
        @back="back"
        @cancel="view = 'list'"
      />
    </div>

    <!--打印 弹窗-->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.cxt"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
    />
  </div>
</template>

<script>
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import cargoAgGridWrapper from '@/components/Cargo/Common/cargoAgGridWrapper.vue'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import pricePrePortDetail from '@/components/Cargo/Price/pricePrePortDetail'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import InquiryList from '@/components/Cargo/Inquiry/inquiryList'
import inquirySeaFclDetail from '@/components/Cargo/Inquiry/inquirySeaFclDetail'
import { cache, cacheName } from '@/utils/cacheManager'

export default {
  name: 'InquirySeaFclList',
  components: {
    cargoTemplateSelectorDialog,
    pricePrePortDetail, cargoAgGridWrapper, searchItem, cargoAdvanceSelect, inquirySeaFclDetail },
  data() {
    return {
      templateSelectorDialog: {
        visible: false,
        cxt: null,
        category: 'SEA_FCL_INQUIRY_PRICE_LIST',
        data: {
          INQUIRY_PRICE_UUID: []
        }
      },
      view: 'list',
      type: SystemConstants.PRICE_INQUIRY_TYPE_SEA_FCL.code,
      SystemConstants,
      loading: false,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
        suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        context: {
          componentParent: this
        },
        // 选中 勾选框触发
        onRowSelected: (event) => {
          this.selectedRows = this.gridApi.getSelectedRows()
        },
        // 行点击触发事件
        onRowClicked: (event) => { this.selectedRow = event.data },
        onRowDoubleClicked: this.onRowDoubleClickedHandler
      },
      columnDefs: [
        {
          headerName: '', width: 55, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_EnquiryNumber'),
          field: 'inquiryPriceNo',
          colId: 'inquiryPriceNo',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_EnquirySource'),
          field: 'source',
          colId: 'source',
          width: 80,
          cellRenderer: (params) => {
            return ColumnUtils.showTypeLabelFunc(params.value, SystemConstants.INQUIRY_SOURCES)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Enquirer'),
          field: 'createdBy',
          colId: 'createdBy',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_EnquiryStatus'),
          field: 'status',
          colId: 'status',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.showTypeLabelFunc(params.value, SystemConstants.INQUIRY_STATUS)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_FirstLegQuoteStatus'),
          field: 'prePortQuotationStatus',
          colId: 'prePortQuotationStatus',
          width: 100,
          wrapText: true,
          autoHeight: true,
          cellStyle: { 'white-space': 'normal', 'line-height': '18px' },
          cellRenderer: (params) => {
            return this.renderQuoteStatusByBiz(params, 'prePort')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_MainlineQuoteStatus'),
          field: 'trunkLineQuotationStatus',
          colId: 'trunkLineQuotationStatus',
          width: 100,
          wrapText: true,
          autoHeight: true,
          cellStyle: { 'white-space': 'normal', 'line-height': '18px' },
          cellRenderer: (params) => {
            return this.renderQuoteStatusByBiz(params, 'trunkLine')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_LastLegQuoteStatus'),
          field: 'lastMileQuotationStatus',
          colId: 'lastMileQuotationStatus',
          width: 100,
          wrapText: true,
          autoHeight: true,
          cellStyle: { 'white-space': 'normal', 'line-height': '18px' },
          cellRenderer: (params) => {
            return this.renderQuoteStatusByBiz(params, 'lastMile')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CartonQuantity'),
          colId: 'seaEq',
          field: 'seaEq',
          width: 200
        },
        {
          headerName: this.$t('SeaExport.CargoReadyDate'),
          colId: 'cargoReadyTime',
          field: 'cargoReadyTime',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.getCargoReadyTimeLabel(params.data)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.getCargoReadyTimeLabel(params.data)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_PalletType'),
          field: 'palletNature',
          colId: 'palletNature',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.showTypeLabelFunc(params.value, SystemConstants.PALLET_NATURES)
          }
        }, {
          headerName: this.$t('SeaExport.ShippingCompany'),
          field: 'carrierId',
          colId: 'carrierId',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_5') : ''
          },
          width: 200
        }, {
          headerName: this.$t('CargoMsg.Cargo_DirectOrTransshipment'),
          field: 'directTransit',
          colId: 'directTransit',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.showTypeLabelFunc(params.value, SystemConstants.DIRECT_TRANSITS)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Airline'),
          field: 'commerceCode',
          colId: 'commerceCode',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Region, 'code', params.value, 'name')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_POL'),
          field: 'pol',
          colId: 'pol',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_PortOfDischarge'),
          field: 'pod',
          colId: 'pod',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_PrePortBusinessLeader'),
          field: 'prePortPlanner',
          colId: 'prePortPlanner',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value || 0), 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_MainlineBusinessLeader'),
          field: 'planner',
          colId: 'planner',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value || 0), 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_LastMileBusinessLeader'),
          field: 'lastMilePlanner',
          colId: 'lastMilePlanner',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value || 0), 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_PrePortQuoteMethod'),
          colId: 'prePortQuotationMethod',
          field: 'prePortQuotationMethod',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.showTypeLabelFunc(params.value, SystemConstants.QUOTATION_METHODS) || ''
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_MainlineQuoteMethod'),
          colId: 'trunkLineQuotationMethod',
          field: 'trunkLineQuotationMethod',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.showTypeLabelFunc(params.value, SystemConstants.QUOTATION_METHODS) || ''
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_EndlineQuoteMethod'),
          colId: 'lastMileQuotationMethod',
          field: 'lastMileQuotationMethod',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.showTypeLabelFunc(params.value, SystemConstants.QUOTATION_METHODS) || ''
          }
        },
        {
          headerName: this.$t('SeaExport.CommodityName'),
          field: 'cargoDescription',
          colId: 'cargoDescription',
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Remarks'),
          field: 'remarks',
          colId: 'remarks',
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_MainlineRejectReason'),
          field: 'trunkLineRefuseReason',
          colId: 'trunkLineRefuseReason',
          tooltipValueGetter: params => params.value,
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_PortRejectReason'),
          field: 'prePortRefuseReason',
          colId: 'prePortRefuseReason',
          tooltipValueGetter: params => params.value,
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_EndlineRejectReason'),
          field: 'lastMileRefuseReason',
          colId: 'lastMileRefuseReason',
          tooltipValueGetter: params => params.value,
          width: 150
        },
        {
          headerName: this.$t('SeaExport.DateOfCreation2'),
          field: 'dateCreated',
          colId: 'dateCreated',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.SubmissionDateTime'),
          field: 'submitDate',
          colId: 'submitDate',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        }
      ],
      rowData: [],
      selectedRows: [],
      selectedRow: null,
      gridApi: null,
      customSearchItems: [], // 自定义高级查询项
      filter: {
        type: SystemConstants.PRICE_INQUIRY_TYPE_SEA_FCL.code,
        total: 0,
        pageNum: 1,
        pageSize: 10
      }
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    await this.init()
  },
  methods: {
    ...InquiryList.methods,
    escapeHtml(text) {
      if (text === null || text === undefined) return ''
      return String(text)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
    },
    getQuoteStatusByBizList(data, quotationType) {
      if (!data) return []
      if (quotationType === 'prePort') return data.prePortQuoteStatusByBiz || []
      if (quotationType === 'trunkLine') return data.trunkLineQuoteStatusByBiz || []
      if (quotationType === 'lastMile') return data.lastMileQuoteStatusByBiz || []
      return []
    },
    renderQuoteStatusByBiz(params, quotationType) {
      const list = this.getQuoteStatusByBizList(params.data, quotationType)
      if (!Array.isArray(list) || list.length === 0) {
        return ''
      }

      const separator = this.$i18n && this.$i18n.locale === 'zh' ? '：' : ': '
      return list.map(item => {
        const businessName = item.businessName ||
          ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(item.businessUserId || 0), 'chineseName') ||
          ''
        const statusLabel = ColumnUtils.showTypeLabelFunc(item.status2, SystemConstants.QUOTE_STATUS) || ''
        const refuseReason = item.refuseReason || item.rejectReason || ''
        const showRejectIcon = item.status2 === SystemConstants.QUOTE_STATUS_REJECTED.code && refuseReason

        const rejectIcon = showRejectIcon
          ? `<span style="display:inline-block;width:12px;height:12px;border:1px solid #F56C6C;border-radius:50%;color:#F56C6C;font-weight:700;margin-left:4px;font-size:12px;line-height:12px;box-sizing:border-box;text-align:center;vertical-align:middle;" title="${this.escapeHtml(refuseReason)}">!</span>`
          : ''

        return `<div style="white-space:normal;line-height:18px;">${this.escapeHtml(businessName)}${separator}${this.escapeHtml(statusLabel)}${rejectIcon}</div>`
      }).join('')
    }
  }
}
</script>

<style scoped lang="scss">
.input-label {
  display: inline-block;
  width: 60px;
  color: #666666;
}
.el-form{
  /deep/ .el-input__inner{
    width: 300px;
  }
}
</style>
